/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent, getContextRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {TeamGroupResource} from '../../../components/api/resources/resource/team-group.resource';
import {PERMISSIONS} from '../../../components/auth/auth-constants';


export function teamGroupStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('team-groups.team-group', TeamGroupResource, 'app.adm', 'app/admin');
    
        $stateProvider.state(rh.listPath(), rh.list({
          data: {
            app: ['ADVERTISING', 'DATA']
          },
          views: {
            'content@app': { component: getRoutePageComponent('team-group-route') }
          },
          resolve: {
            readOnly: /*@ngInject*/ function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
                && !LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
                && !LocalUserPermissions.hasNetwork(PERMISSIONS.axAdvertiserAdmin.apiKey);
            }
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: _.merge({}, adminResourceItemRouteResolve('team-group-item', 'item')),
            views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'TeamGroup'));
  }, adnRouterHelper);
}
